import React from "react";
import { motion } from "framer-motion";
import { Music2 } from "lucide-react";
import { useSelector } from "react-redux";
import { tiktokText } from "i18n/tiktokText";
import background from "../Fbchatplusgin/light-yellow.jpg";

const TikTokSection = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = tiktokText[lang];

  return (
    <section
      id="tiktok"
      className="relative py-16 lg:py-24 overflow-hidden px-6"
      style={{
        background:
          "linear-gradient(135deg, #fff8fa 0%, #fefcff 50%, #f5ffff 100%)",
      }}
    >
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm" />

      <div className="relative max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-sm uppercase tracking-widest text-gray-500 mb-3">
              {t.subtitle}
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
              {t.title}
              <br />
              <span className="text-pink-600">{t.highlight}</span>
            </h2>

            <p className="text-gray-600 mt-5 max-w-md">{t.desc}</p>

            <a
              href="https://www.tiktok.com/@trambuituvanhuongnghiep"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-black text-white hover:bg-pink-600 transition-all duration-300"
            >
              <Music2 size={18} />
              {t.cta}
            </a>
          </motion.div>

          {/* RIGHT */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
              {/* HEADER */}
              <div
                className="flex items-center justify-between px-5 py-4 border-b cursor-pointer"
                onClick={() =>
                  window.open(
                    "https://www.tiktok.com/@trambuituvanhuongnghiep",
                    "_blank",
                  )
                }
              >
                <div>
                  <p className="font-semibold text-gray-900">{t.pageName}</p>

                  <p className="text-xs text-gray-500">{t.pageLabel}</p>
                </div>

                <Music2 className="text-pink-600" />
              </div>

              {/* PROFILE PREVIEW */}
              <div className="p-8 text-center">
                <img
                  src="/images/tiffany_tiktok.jpeg"
                  alt="TikTok"
                  className="w-24 h-24 rounded-full mx-auto object-cover"
                />

                <h3 className="mt-4 font-semibold text-gray-900">
                  Tiffany Bui
                </h3>

                <p className="text-gray-500 text-sm mt-2">
                  Career Counsellor • New Zealand
                </p>

                <div className="grid grid-cols-3 gap-4 mt-6 text-center">
                  <div>
                    <p className="font-bold text-gray-900">500+</p>
                    <p className="text-xs text-gray-500">Videos</p>
                  </div>

                  <div>
                    <p className="font-bold text-gray-900">10K+</p>
                    <p className="text-xs text-gray-500">Likes</p>
                  </div>

                  <div>
                    <p className="font-bold text-gray-900">2K+</p>
                    <p className="text-xs text-gray-500">Followers</p>
                  </div>
                </div>

                <a
                  href="https://www.tiktok.com/@trambuituvanhuongnghiep"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex mt-6 px-6 py-3 rounded-full bg-pink-600 text-white hover:bg-pink-700 transition"
                >
                  {t.cta}
                </a>
              </div>

              {/* FOOTER */}
              <div className="text-center py-3 text-sm text-gray-500 border-t">
                {t.footer}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TikTokSection;
